module.exports = __webpack_public_path__ + "hbomaxar-static/media/LiquidTrip_SmallLoop_00021.4f630eb5.png";